module.exports = __webpack_public_path__ + "static/media/d13.a809fc0b.jpg";